export class UserFoto {
  constructor(public email, public photo) {}
}
